import React from 'react';
import ReactDOM from 'react-dom';
import autoBind from 'react-autobind';
import { Provider } from 'unstated';
import { BrowserRouter, Switch } from 'react-router-dom';
import ThemeWrapper from './themes/ThemeWrapper';
import noty from './lib/noty';
import { getToken } from './lib/auth';
import { renderRoutes } from './routing';
import feathers from './feathers';
import registerServiceWorker from './registerServiceWorker';
import { UserAccountContext } from './contexts/userAccount';

import {
  BuildingRecord,
  CurrentAccountRecord,
  FacilityRecord,
  FloorRecord,
  GroupRecord,
  InvitationRecord,
  MarkerRecord,
  MarkerTypeCategoryRecord,
  MarkerTypeRecord,
  PermissionRecord,
  PlanRecord,
  TrainingRecord,
  UserRecord
} from './feathers/records';
import ConfirmModal from './components/ConfirmModal';
import { appContainer } from './contexts/app';
import SubscriptionStatus from './components/SubscriptionStatus';
import 'flexboxgrid';
import './style.scss';

export class App extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      appReady: false,
      account: null,
      subscriptionStatus: {
        active: true
      }
    };
  }

  async prepApp() {
    await this.checkAuthenticated();
    await this.fetchUser();
    await this.fetchAllTheThings();

    this.setState({ appReady: true });
  }

  async checkAuthenticated() {
    if (!getToken()) {
      window.location.assign('/login');
      return;
    }

    try {
      if (!appContainer.state.get('authenticated')) {
        await feathers._authenticate();
      }
    } catch (e) {
      window.location.assign('/login');
    }
  }

  async getSubscriptionStatus(currentAccount) {
    let subscriptionServiceInfo = await feathers
      .service('api/subscription-status')
      .get(currentAccount._id);

    return new SubscriptionStatus(subscriptionServiceInfo);
  }

  handleCheckSubscription = async () => {
    const { account } = this.state;

    const subscriptionStatus = await this.getSubscriptionStatus(account);
    this.setState({ subscriptionStatus });
  };

  async fetchUser() {
    let [currentAccount] = await Promise.all([
      CurrentAccountRecord.getCurrentAccount(),
      CurrentAccountRecord.loadSessions(),
      UserRecord.getCurrentUser()
    ]);

    const subscriptionStatus = await this.getSubscriptionStatus(currentAccount);
    let currentSession = appContainer.state.getIn([
      'sessions',
      currentAccount._id
    ]);

    appContainer.set('ownerName', currentSession.get('owner_name'));
    appContainer.set('trialWarningOpen', subscriptionStatus.trialWarning);
    this.setState({
      subscriptionStatus,
      account: currentAccount
    });
  }

  async fetchAllTheThings() {
    await Promise.all([
      BuildingRecord.find(),
      FacilityRecord.find(),
      FloorRecord.find(),
      MarkerTypeCategoryRecord.find(),
      MarkerTypeRecord.find(),
      MarkerRecord.find(),
      UserRecord.find(),
      InvitationRecord.find(),
      GroupRecord.find({ paginate: false }),
      PermissionRecord.find(),
      PlanRecord.find(),
      TrainingRecord.find()
    ]);
  }

  getUserConfirmation(message, callback) {
    noty.confirm(message, {
      onOk: () => {
        callback(true);
      },
      onCancel: () => {
        callback(false);
      }
    });
  }

  renderMyRoutes() {
    const { appReady, subscriptionStatus } = this.state;
    let { active } = subscriptionStatus;
    return renderRoutes({
      active,
      prepApp: this.prepApp,
      appReady
    });
  }

  render() {
    let { account, subscriptionStatus } = this.state;
    const onUpdateSubscription = this.handleCheckSubscription;
    return (
      <Provider>
        <UserAccountContext.Provider
          value={{ account, subscriptionStatus, onUpdateSubscription }}
        >
          <ThemeWrapper>
            <div>
              <BrowserRouter
                basename="/"
                getUserConfirmation={this.getUserConfirmation}
              >
                <div>
                  <Switch>{this.renderMyRoutes()}</Switch>
                </div>
              </BrowserRouter>
              <ConfirmModal />
            </div>
          </ThemeWrapper>
        </UserAccountContext.Provider>
      </Provider>
    );
  }
}

ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js